<template>
	<div class="xs-12">
		<core-form-input
			componentName="j-base-input-text"
			name="title"
			:label="$t('title')"
			v-validate="'required'"
			v-model="form.title"
			:validationErrors="errors"
		/>

		<core-form-input
			class="mt6"
			componentName="j-base-input-long-text"
			name="text"
			:label="$t('text')"
			v-validate="'required'"
			v-model="form.content"
			:validationErrors="errors"
		/>

		<div class="mt6">
			<slot :onSubmit="onSubmit"></slot>
		</div>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
export default {
	components: { CoreFormInput },

	props: {
		data: {
			type: Object,
			required: false,
			default: () => ({
				title: null,
				content: null
			})
		}
	},

	data() {
		return {
			form: {}
		}
	},

	methods: {
		async onSubmit() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			this.$emit("submit", this.form)
		}
	},

	watch: {
		data: {
			handler() {
				this.form = { ...this.data }
			},
			immediate: true,
			deep: true
		}
	}
}
</script>
